<div class="search-dd">
  <div class="searchContainer">
    <input
      #searchBox
      class="searchBox"
      autocomplete="no-autofill"
      [formControl]="searchControl"
      type="search"
      placeholder="{{ 'shared.search' | translate }} {{ 'user.' + entity().toLowerCase() | translate | uppercase }}"
      />
      <mat-icon class="search">search</mat-icon>
    </div>
    @if (isSearching() && (searchControl.value || '').trim()) {
      <div class="searchResults">
        <ul>
          @for (record of textSearch(); track record) {
            <li (click)="addRecord(record)">
              {{ record.value }}
            </li>
          }
        </ul>
        @if (textSearch().length === 0) {
          <span>{{ 'shared.noRecords' | translate }}</span>
        }
      </div>
    }
    <ng-content></ng-content>
  </div>
